const MAX_BAR_WIDTH = 100;

/**
 * Score Normalization:
 * Backend sends: 1.0 (GREEN/sufficient) to 3.0 (RED/deficient)
 * UI needs: 0-100 (inverted - higher is better)
 * 
 * Conversion:
 * - 1.0 (sufficient) → 100 (full bar, green)
 * - 2.0 (moderate)   → 50 (medium bar, yellow)
 * - 3.0 (deficient)  → 0 (minimal bar, red)
 */
function normalizeScore(score: number): number {
  // If score is already 0-100 range (legacy), use as-is
  if (score > 3) return score;
  
  // Convert 1.0-3.0 to 100-0 (inverted scale)
  // Formula: (3 - score) / 2 * 100
  const normalized = ((3 - score) / 2) * 100;
  
  // Clamp to 0-100
  return Math.max(0, Math.min(100, normalized));
}

export const metricRules = {
  barWidth(score: number) {
    const normalizedScore = normalizeScore(score);
    return Math.round((normalizedScore / 100) * MAX_BAR_WIDTH);
  },

  barColor(score: number) {
    const normalizedScore = normalizeScore(score);
    if (normalizedScore >= 70) return '#0ca182'; // GREEN (1.0-1.4)
    if (normalizedScore >= 20) return '#fdd306'; // YELLOW (1.4-2.5)
    return '#dc3030';                            // RED (2.5-3.0)
  },

  label(score: number) {
    const normalizedScore = normalizeScore(score);
    if (normalizedScore >= 70) return 'Good';
    if (normalizedScore >= 20) return 'Normal';
    return 'Low';
  },
};
